import React from 'react';
import { ClockIcon, BadgeCheckIcon, ImageIcon, UsersIcon, ShieldIcon, RefreshCwIcon } from 'lucide-react';
const Benefits = () => {
  return <section id="benefits" className="py-16 bg-blue-50" data-id="element-11">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-14">
            選ばれる理由
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-15">
            業界最高水準の品質と信頼性を備えた清掃スタッフをご提供いたします。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-16">
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-17">
            <div className="flex items-center mb-4" data-id="element-18">
              <div className="bg-blue-100 rounded-full p-3 mr-4" data-id="element-19">
                <ClockIcon className="h-6 w-6 text-blue-600" data-id="element-20" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-21">迅速な対応</h3>
            </div>
            <p className="text-gray-700" data-id="element-22">
              ご依頼から24時間以内にスタッフを手配。緊急時の代替スタッフも即時対応可能です。
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-23">
            <div className="flex items-center mb-4" data-id="element-24">
              <div className="bg-blue-100 rounded-full p-3 mr-4" data-id="element-25">
                <BadgeCheckIcon className="h-6 w-6 text-blue-600" data-id="element-26" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-27">研修制度</h3>
            </div>
            <p className="text-gray-700" data-id="element-28">
              全スタッフが清掃技術、接客マナー、セキュリティ対策の専門研修を修了しています。
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-29">
            <div className="flex items-center mb-4" data-id="element-30">
              <div className="bg-blue-100 rounded-full p-3 mr-4" data-id="element-31">
                <ImageIcon className="h-6 w-6 text-blue-600" data-id="element-32" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-33">作業報告書</h3>
            </div>
            <p className="text-gray-700" data-id="element-34">
              清掃完了後、写真付きの詳細な作業報告書をご提出し、品質を確認いただけます。
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-35">
            <div className="flex items-center mb-4" data-id="element-36">
              <div className="bg-blue-100 rounded-full p-3 mr-4" data-id="element-37">
                <UsersIcon className="h-6 w-6 text-blue-600" data-id="element-38" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-39">多言語対応</h3>
            </div>
            <p className="text-gray-700" data-id="element-40">
              日本語・英語でのカスタマーサポートを提供し、国際的なお客様のニーズにお応えします。
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-41">
            <div className="flex items-center mb-4" data-id="element-42">
              <div className="bg-blue-100 rounded-full p-3 mr-4" data-id="element-43">
                <ShieldIcon className="h-6 w-6 text-blue-600" data-id="element-44" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-45">品質保証</h3>
            </div>
            <p className="text-gray-700" data-id="element-46">
              清掃品質に満足いただけない場合、追加料金なしで再清掃を実施いたします。
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-47">
            <div className="flex items-center mb-4" data-id="element-48">
              <div className="bg-blue-100 rounded-full p-3 mr-4" data-id="element-49">
                <RefreshCwIcon className="h-6 w-6 text-blue-600" data-id="element-50" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-51">
                柔軟なスケジュール
              </h3>
            </div>
            <p className="text-gray-700" data-id="element-52">
              定期清掃から単発の依頼まで、オンラインで簡単にスケジュール調整が可能です。
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Benefits;